import React, { useEffect, useState } from "react";
import backgroundImage from "../assets/bg-image.png";
import englishIcon from "../assets/Englishlangicon.png";
import hindiIcon from "../assets/HindiIcon.png";
import gujratiIcon from "../assets/GujratiIcon.png";
import bengaliIcon from "../assets/BengaliIcon.png";
import tamilIcon from "../assets/TamilIcon.png";
import teluguIcon from "../assets/TeleguIcon.png";
import kanadaIcon from "../assets/KannadaIcon.png";
import marathiIcon from "../assets/MarathiIcon.png";
import punjabiIcon from "../assets/PunjabiIcon.png";
// Replace with the focused versions of icons if available
import englishIconFocused from "../assets/EnglishlangiconFocused.png";
import hindiIconFocused from "../assets/HindilangiconFocused.png";
import gujratiIconFocused from "../assets/GujaratilangiconFocused.png";
import bengaliIconFocused from "../assets/BengalilangiconFocused.png";
import tamilIconFocused from "../assets/TamillangiconFocused.png";
import teluguIconFocused from "../assets/TelugulangiconFocused.png";
import kanadaIconFocused from "../assets/KanadalangiconFocused.png";
import marathiIconFocused from "../assets/MarathilangiconFocused.png";
import punjabiIconFocused from "../assets/PunjabilangiconFocused.png";
import languagebackgroundblack from "../assets/languagebackgroundblack.png";
import languagebackgroundorange from "../assets/languagebackgroundorange.png";

import English_unselected from "../assets/English_unselected.png";
import Hindi_unselected from "../assets/Hindi_unselected.png";
import Tamil_unselected from "../assets/Tamil_unselected.png";
import Telugu_unselected from "../assets/Telugu_unselected.png";
import Kanada_unselected from "../assets/Kannada_unselected.png";
import Gujrati_unselected from "../assets/Gujarati_unselected.png";
import Punjabi_unselected from "../assets/Punjab_unselected.png";
import Marathi_unselected from "../assets/Marathi_unselected.png";
import Malayalam_unselected from "../assets/Malayalam_unselected.png";
import Bengali_unselected from "../assets/Bengali_unselected.png";
import English_selected from "../assets/English_selected.png";
import Hindi_selected from "../assets/Hindi_selected.png";
import Tamil_selected from "../assets/Tamil_selected.png";
import Telugu_selected from "../assets/Telugu_selected.png";
import Kanada_selected from "../assets/Kannada_selected.png";
import Gujrati_selected from "../assets/Gujarati_selected.png";
import Punjabi_selected from "../assets/Punjabi_selected.png";
import Marathi_selected from "../assets/Marathi_selected.png";
import Malayalam_selected from "../assets/Malayalam_selected.png";
import Bengali_selected from "../assets/Bengali_selected.png";
import background_img from "../assets/background_img.png";
import CustomButton from "./CustomButton";
import Wrapper from "./shared/Wrapper";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";

let resolution = window.RESOLUTION;

const SelectedLanguage = ({ navigate }) => {
  const [focusedElement, setFocusedElement] = useState({
    type: "language",
    index: 0,
  });
  const [selectedLanguage, setSelectedLanguage] = useState(null);

  const languages = [
    {
      name: "English",
      icon: English_unselected,
      focusedIcon: English_selected,
      language: "English",
    },
    {
      name: "हिंदी",
      icon: Hindi_unselected,
      focusedIcon: Hindi_selected,
      language: "Hindi",
    },
    {
      name: "ગુજરાતી",
      icon: Gujrati_unselected,
      focusedIcon: Gujrati_selected,
      language: "Gujarati",
    },
    {
      name: "বাংলা",
      icon: Bengali_unselected,
      focusedIcon: Bengali_selected,
      language: "Bangla",
    },
    {
      name: "தமிழ்",
      icon: Tamil_unselected,
      focusedIcon: Tamil_selected,
      language: "Tamil",
    },
    {
      name: "తెలుగు",
      icon: Telugu_unselected,
      focusedIcon: Telugu_selected,
      language: "Telugu",
    },
    {
      name: "ಕನ್ನಡ",
      icon: Kanada_unselected,
      focusedIcon: Kanada_selected,
      language: "Kannada",
    },
    {
      name: "मराठी",
      icon: Marathi_unselected,
      focusedIcon: Marathi_selected,
      language: "Marathi",
    },
    {
      name: "Punjabi",
      icon: Punjabi_unselected,
      focusedIcon: Punjabi_selected,
      language: "Punjabi",
    },
    {
      name: "Malayalam",
      icon: Malayalam_unselected,
      focusedIcon: Malayalam_selected,
      language: "Malayalam",
    },
  ];

  const numCols = 3;

  const handleLanguageSelect = (lang, index) => {
    setSelectedLanguage(lang);
    setFocusedElement({ type: 'button', index: 0 });
  };

  const handleProceed = () => {
    if (selectedLanguage) {
      localStorage.setItem("AppLanguage", selectedLanguage);
      localStorage.setItem("LoginScreen", "LoginPage");
      sendTestMatomoEvent({ action_name: `App - Select - LanguagePreference(${selectedLanguage})` });
      navigate("LoginScreen");
    }
  };

  const SelectedLanguageKeyDown = (event) => {
    switch (event.keyCode) {
      case 13: // Enter
         if (focusedElement.type === "language") {
          const { language, index } = languages[focusedElement.index];
          handleLanguageSelect(language, index);
        } else if (focusedElement.type === "button") {
          handleProceed();
        }
        break;
      case 37: // Left arrow
        if (focusedElement.type === "language") {
          setFocusedElement((prev) => ({
            ...prev,
            index: prev.index > 0 ? prev.index - 1 : prev.index,
          }));
        }
        break;
      case 39: // Right arrow
        if (focusedElement.type === "language") {
          setFocusedElement((prev) => ({
            ...prev,
            index:
              prev.index < languages.length - 1 ? prev.index + 1 : prev.index,
          }));
        }
        break;
      case 38: // Up arrow
        if (focusedElement.type === "language") {
          setFocusedElement((prev) => ({
            ...prev,
            index:
              prev.index - numCols >= 0 ? prev.index - numCols : prev.index,
          }));
        } else if (focusedElement.type === "button") {
          setFocusedElement({ type: "language", index: languages.length - 1 });
        }
        break;
      case 40: // Down arrow
        if (focusedElement.type === "language") {
          if (focusedElement.index + numCols < languages.length) {
            setFocusedElement((prev) => ({
              ...prev,
              index: prev.index + numCols,
            }));
          } else {
            setFocusedElement({ type: "button", index: 0 });
          }
        }
        break;
      case 461:
      case 10009:
        if (window.tizen) {
            sendTestMatomoEvent({ action_name: `App - End` });
          window.tizen.application.getCurrentApplication().exit();
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    // localStorage.setItem("AppLanguage", "English");
    window.addEventListener("keydown", SelectedLanguageKeyDown);
    return () => {
      window.removeEventListener("keydown", SelectedLanguageKeyDown);
    };
  }, [focusedElement, selectedLanguage]);

  const langSelect = (lang, index) => {
    setSelectedLanguage(lang);
    setFocusedElement({ type: "language", index });
  };

  const backgroundStyle = {
    backgroundImage: `url(${background_img})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    height: "100%",
  };

  const layertransparent = {
    width: "100%",
    height: "100%",
    backgroundImage: `url(${background_img})`,
    opacity: "0.9",
    position: "absolute",
  };

  const languageselection = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    padding: "1rem",
  };

  const languagegrid = {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "2rem",
    position: "relative",
    bottom: "2rem",
  };

  const languagebutton = (isFocused, isSelected) => ({
    width: "34vh",
    height: "19vh",
    borderWidth: "1px 1px 0px 1px",
    borderStyle: "solid",
    padding: "1rem",
    borderRadius: "1rem",
    backgroundSize: "cover",
  });

  const languageicon = {
    float: "right",
    position: "relative",
    width: "15rem",
    height: "9rem",
    zIndex: "-1",
  };

  const applanguage = {
    textAlign: "center",
    fontSize: "48px",
    marginBottom: "1rem",
    FontFamily: "Anek Latin",
    fontWeight: 700,
  };

  const preferredlanguage = {
    fontSize: "28px",
    FontFamily: "Anek Latin",
    fontWeight: 400,
    position: "relative",
    bottom: "2rem",
  };

  const languagename = {
    fontSize: "3rem",
  };

  // const styles = {
  //   welcomeContainer: {
  //     FontFamily: "Anek Latin",
  //     display: "flex",
  //     flexDirection: "column",
  //     justifyContent: "center",
  //     alignItems: "center",
  //     color: "#333",
  //     fontSize: "1.5em",
  //     backgroundSize: "cover",
  //     backgroundPosition: "center",
  //     backgroundRepeat: "no-repeat",
  //     overflow: "hidden",
  //     fontWeight: 600,
  //   },
  //   customButton: (isFocused) => ({
  //     width: resolution === "FHD" ? "30rem" : "30rem",
  //     height: resolution === "FHD" ? "6rem" : "6rem",
  //     fontSize: resolution === "FHD" ? "24px" : "18px",
  //     outline: isFocused ? "4px solid #ffff" : "none",
  //   }),
  // };

  const isButtonFocused = focusedElement.type === "button";
  const isLanguageSelected = selectedLanguage !== null;

  // Corrected logic for the Proceed button style
  const proceedButtonStyles = {
    width: resolution === "FHD" ? "30rem" : "30rem",
    height: resolution === "FHD" ? "6rem" : "6rem",
    fontSize: resolution === "FHD" ? "24px" : "18px",
    outline: isButtonFocused ? "4px solid #ffff" : "none",
    cursor: isLanguageSelected ? 'pointer' : 'default',

    // Applying correct colors and opacity
    backgroundColor: '#EC008C', // Always pink as requested
    opacity: isButtonFocused ? 1 : 0.6, // Opacity changes based on focus only
  };

  return (
    <div style={backgroundStyle}>
      <div style={layertransparent}>
        <div style={languageselection}>
          <h1 style={applanguage}>Select Your App Language Preference</h1>
          <p style={preferredlanguage}>
            Select your preferred language for app
          </p>
          <div style={languagegrid}>
            {languages.map((language, index) => {
              const isFocused = focusedElement.type === "language" && focusedElement.index === index;
              const isSelected = selectedLanguage === language.language;
              return(
              <Wrapper
                key={index}
                onClick={() => handleLanguageSelect(language.language, index)}
                onKeyDown={SelectedLanguageKeyDown}
                onMouseEnter={() => setFocusedElement({ type: "language", index })}
                style={{
                  borderRadius: "1rem",
                  outline: isFocused ? "4px solid #ffff" : "none",
                  overflow: 'hidden',
                }}
              >
                <img
                  src={isSelected ? language.focusedIcon : language.icon}
                  alt={`${language.name} icon`}
                  style={languageicon}
                />
              </Wrapper>
              )})}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "1rem",
            }}
          >
            <CustomButton
              position="block"
              fontSize={resolution === "FHD" ? "24px" : "20px"}
              // defaultSelected={focusedElement.type === "button"}
              style={proceedButtonStyles}
              width="2rem"
              onClick={handleProceed}
              onKeyDown={SelectedLanguageKeyDown}
              onMouseEnter={() => setFocusedElement({ type: "button", index: 0 })}
            >
              Proceed
            </CustomButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectedLanguage;
